<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '100%', margin: '1rem', 'max-width': '700px' }"
  [closable]="false"
  (onHide)="close()"
>
  <form [formGroup]="editHistoryForm" (ngSubmit)="save()">
    <div class="edit-body">
      <div class="header">Hours</div>
      <div class="time-group">
        @for (input of editHistoryInputs.timeInputs; track $index) {
        <div class="edit-time">
          <div class="label">{{ input.label }}</div>
          <input
            [formControlName]="input.formControlName"
            type="text"
            (keydown)="onKeyDown($event, input.formControlName)"
            inputmode="numeric"
            placeholder="HH:MM"
          />
        </div>
        }
      </div>
      <div class="header">Days</div>
      <div class="days-group">
        @for (input of editHistoryInputs.dayInputs; track $index) {
        <div class="edit-days">
          <div class="label">{{ input.label }}</div>
          <input [formControlName]="input.formControlName" type="number" inputmode="numeric" placeholder="0" />
        </div>
        }
      </div>
    </div>
    <div class="flex width-100">
      <app-button
        class="width-100"
        icon="pi pi-sync"
        label="Refresh Month Data"
        [outlined]="true"
        [text]="true"
        (click)="refreshRecord(data)"
      />
    </div>
    <div class="flex flex-end gap-1">
      <p-button label="Cancel" severity="info" [text]="true" (onClick)="close()" />
      <p-button type="submit" label="Save" severity="info" [outlined]="globalService.theme() === 'dark'" />
    </div>
  </form>
</p-dialog>
